import * as THREE from 'three'

// Singleton unit-cube source used as panel source. The downstream `usePanel`
// hook clones this with `cloneWithIndependentMaterials`, anchors it at bbox
// min, then scales by [thickness, height, depth] mm.
let cachedPanelSource: THREE.Object3D | null = null

const getProceduralPanelSource = (): THREE.Object3D => {
  if (cachedPanelSource) return cachedPanelSource

  const geometry = new THREE.BoxGeometry(1, 1, 1)
  geometry.computeBoundingBox()

  const material = new THREE.MeshStandardMaterial({ color: '#ffffff' })
  const mesh = new THREE.Mesh(geometry, material)
  mesh.castShadow = true
  mesh.receiveShadow = true

  const root = new THREE.Group()
  root.add(mesh)
  root.updateMatrixWorld(true)

  cachedPanelSource = root
  return root
}

export const usePanelSource = (): THREE.Object3D => {
  return getProceduralPanelSource()
}
